"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCore = void 0;
var core_1 = require("@inter-ikea-core/core");
var core_2 = require("@inter-ikea-core/core");
var core_3 = require("@inter-ikea-core/core");
var DragUtils_1 = require("../drag/DragUtils");
var createCore = function (withRoom, withAutoAdapt, withHistory) {
    if (withRoom === void 0) { withRoom = true; }
    if (withAutoAdapt === void 0) { withAutoAdapt = false; }
    if (withHistory === void 0) { withHistory = false; }
    var core = (0, core_1.createCore)();
    core.addValidation(new core_3.RequiredConnectorsSatisfiedValidation());
    if (withHistory) {
        core.addHistoryModule();
    }
    var autoAdaptService = null;
    if (withAutoAdapt) {
        autoAdaptService = new core_3.AutoAdaptService(core.services);
        core_1.AutoAdaptFeature.start(core.services);
    }
    DragUtils_1.DragUtils.addLegacyDrag(core.services, withAutoAdapt);
    var placementService = new core_3.PlacementService(core.services, autoAdaptService);
    var room = null;
    var roomService = new core_3.RoomService(core.services.entityManager, core.services.sceneManager);
    if (withRoom) {
        var roomSystem = new core_3.RoomSystem(roomService, core.services);
        core.services.entityManager.registerSystem(roomSystem);
        room = roomService.createOrUpdateRectangularRoom(new core_2.Vector(10000, 5000, 10000));
    }
    return {
        core: core,
        placementService: placementService,
        autoAdaptService: autoAdaptService,
        room: room,
        roomService: roomService
    };
};
exports.createCore = createCore;
//# sourceMappingURL=core_creator.js.map